import {useTitle} from 'hooks';
import {useParams} from 'react-router-dom';
import {Transitioner} from 'components';

interface IPageAnalyticsProps {}

const PageAnalytics = ({}: IPageAnalyticsProps) => {
  useTitle('Analytics');

  const params = useParams();
  const workspace = params.workspace ?? '';
  const resource = params.resource ?? '';

  return (
    <Transitioner key={`/${workspace}/${resource}`}>
      <h1>ANALYTICS</h1>
    </Transitioner>
  );
};

export default PageAnalytics;
